import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-footer-image',
    templateUrl: './footer-image.component.html',
    styleUrl: './footer-image.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterImageComponent {

}
